import { DEFAULT_OPTION_ALL } from "@/constants";

export const EDITOR_PLUGINS = [
  "advlist autolink lists link image charmap print preview anchor",
  "searchreplace visualblocks code fullscreen",
  "insertdatetime media table paste code wordcount"
];

export const EDITOR_TOOLBAR =
  "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile pageembed template link codesample | a11ycheck ltr rtl | showcomments addcomment";

export const EDITOR_API_KEY = process.env.VUE_APP_TINY_API_KEY;

export const statusSelect = [
  ...DEFAULT_OPTION_ALL,
  {
    id: "Official",
    name: "progress_report.official"
  },
  {
    id: "Draft",
    name: "progress_report.draft"
  },
  {
    id: "Pending",
    name: "progress_report.pending"
  },
  {
    id: "Not-approve",
    name: "submitted_report.reject"
  }
];

export function getClassStatus(status) {
  let classUse = "";
  switch (status) {
    case "Draft":
      classUse = "bg-[#F6C3FF]";
      break;
    case "Official":
      classUse = "bg-[#C0FFE1]";
      break;
    case "Pending":
      classUse = "bg-[#FFE9B9]";
      break;
    case "Not-approve":
      classUse = "bg-[#FFCCC8]";
  }
  return classUse;
}

export const SENDING_MODE = {
  NO_REVIEW: "No-review",
  REVIEW: "Review"
};
export const STATUS = {
  OFFICIAL: "Official",
  DRAFT: "Draft",
  PENDING: "Pending",
  NOT_APPROVE: "Not-approve"
};

export function setStatusSendEmail(form) {
  const { type_sending_model: typeSendingMode, status } = form;
  if (typeSendingMode === SENDING_MODE.NO_REVIEW) return STATUS.OFFICIAL;
  if (
    typeSendingMode === SENDING_MODE.REVIEW &&
    (form.status === STATUS.DRAFT || form.status === STATUS.NOT_APPROVE)
  )
    return STATUS.PENDING;
  if (typeSendingMode === SENDING_MODE.REVIEW && status === STATUS.OFFICIAL)
    return STATUS.OFFICIAL;
}

export function setContentSendBtn(form) {
  const { type_sending_mode: typeSendingMode, status } = form;
  if (typeSendingMode === SENDING_MODE.NO_REVIEW && status === STATUS.DRAFT)
    return "progress_report.save_and_send_email";
  if (typeSendingMode !== SENDING_MODE.NO_REVIEW && status === STATUS.DRAFT)
    return "progress_report.send_and_review";
  if (status === STATUS.OFFICIAL) return "progress_report.send_email_again";
  if (status === STATUS.NOT_APPROVE)
    return "progress_report.send_and_review_again";
}

export const learningBehaviors = () => {
  return [
    {
      name: "1. Recall previous knowledge",
      text_vietnamese: "Khả năng nhớ kiến thức cũ",
      key: "recall_previous_knowledge",
      us_teacher: "",
      homeroom_teacher: "",
      first_teacher: "",
      second_teacher: ""
    },
    {
      name: "2. Understand new concept",
      text_vietnamese: "Khả năng hiểu bài mới",
      key: "understand_new_concept",
      us_teacher: "",
      homeroom_teacher: "",
      first_teacher: "",
      second_teacher: ""
    },
    {
      name: "3. Produce language/content output",
      text_vietnamese: "Khả năng áp dụng kiến thức vào thực hành",
      key: "produce_language_content_output",
      us_teacher: "",
      homeroom_teacher: "",
      first_teacher: "",
      second_teacher: ""
    },
    {
      name: "4. Understand & Follow instructions",
      text_vietnamese: "Hiểu và làm theo hướng dẫn của giáo viên",
      key: "understand_and_follow_instructions",
      us_teacher: "",
      homeroom_teacher: "",
      first_teacher: "",
      second_teacher: ""
    },
    {
      name: "5. Engagement",
      text_vietnamese: "Khả năng tương tác trong lớp học",
      key: "engagement",
      us_teacher: "",
      homeroom_teacher: "",
      first_teacher: "",
      second_teacher: ""
    }
  ];
};
